
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useServiceTypes = () => {
  return useQuery({
    queryKey: ['serviceTypes'],
    queryFn: async () => {
      console.log('Fetching service types from database');
      const { data: serviceTypesResult, error } = await supabase
        .rpc('get_unique_service_types');

      if (error) {
        console.error('Error fetching service types:', error);
        throw error;
      }

      // Extract service types from the result
      const serviceTypes = serviceTypesResult.map(row => row.service_type);
      console.log('Fetched service types:', serviceTypes);
      return serviceTypes;
    },
  });
};
